import { createSlice } from '@reduxjs/toolkit';

const reCaptcha = createSlice({
  name: 'reCaptcha',
  initialState: {
    reCaptchaToken: '',
    isValidReCaptcha: false,
  },
  reducers: {
    setReCaptchaToken(state, action) {
      state.reCaptchaToken = action.payload;
    },
    setIsValidReCaptcha(state, action) {
      state.isValidReCaptcha = action.payload;
    },
  },
});

export const { setReCaptchaToken, setIsValidReCaptcha } = reCaptcha.actions;

export default reCaptcha.reducer;
